export default __webpack_public_path__ + "static/docs0-4e06f3a5958c77bc2a964c7f2a555958.png";